<template>
  <div class="section-background">
    <success-snackbar
      v-if="showSuccessSnackbar"
      :snackbarText="snackbarText"
      @hidde="showSuccessSnackbar = false"
    />
    <v-row no-gutters align="center">
      <h3 class="section-name">Відгуки</h3>
      <v-row no-gutters align="center" justify="end">
        <admin-submit-button @click="showCreateReviewModal = true"
          ><v-icon color="#FFFFFF" style="margin-right: 4px" size="22px"
            >mdi-plus</v-icon
          >Додати відгук</admin-submit-button
        >
      </v-row>
    </v-row>
    <loader v-if="isShowLoader" />
    <div
      style="
        height: 200px;
        display: grid;
        place-items: center;
        margin-top: 16px;
      "
      v-else-if="reviews.length === 0"
    >
      <p style="margin: 0px">Жодної послуги не було додано</p>
    </div>
    <div style="margin-top: 30px" v-else>
      <review-card
        v-for="review in reviews"
        :key="review.id"
        :review="review"
        @setItemForEdit="setItemForEdit"
        @deleteReview="deleteReview"
      />
    </div>

    <create-review-modal
      v-if="showCreateReviewModal"
      :visible="showCreateReviewModal"
      :isEdit="isEdit"
      :itemForEdit="itemForEdit"
      @success="success"
      @close="showCreateReviewModal = false"
    />
  </div>
</template>

<script>
import adminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";
import SuccessSnackbar from "../../UI/Snackbars/successSnackbar.vue";
import CreateReviewModal from "./createReviewModal.vue";
import ReviewCard from "./reviewsCard.vue";
import reviewService from "../../../requests/Admin/reviewService";
import Loader from "../../UI/Loader.vue";
export default {
  components: {
    adminSubmitButton,
    CreateReviewModal,
    SuccessSnackbar,
    ReviewCard,
    Loader,
  },
  data: () => ({
    reviews: [
      { id: 1, name: "Review 1", description: "Description of Review 1" },
      { id: 2, name: "Review 2", description: "Description of Review 2" },
      { id: 3, name: "Review 3", description: "Description of Review 3" },
    ],
    showCreateReviewModal: false,
    showSuccessSnackbar: false,
    isShowLoader: true,
    isEdit: false,
    itemForEdit: {},
    snackbarText: "",
  }),
  mounted() {
    this.getReviews();
  },
  methods: {
    async getReviews() {
      await reviewService.getReviews().then((res) => {
        this.reviews = res;
        this.isShowLoader = false;
      });
    },
    async deleteReview(id) {
      await reviewService.deleteReview(id).then(() => {
        this.snackbarText = "Відгук успішно видалено";
        this.showSuccessSnackbar = true;
        this.isShowLoader = true;
        this.getReviews();
      });
    },
    success(snackbarText) {
      this.showCreateReviewModal = false;
      this.showSuccessSnackbar = true;
      this.snackbarText = snackbarText;
      this.isShowLoader = true;
      this.getReviews();
    },
    setItemForEdit(item) {
      this.itemForEdit = item;
      this.isEdit = true;
      this.showCreateReviewModal = true;
    },
  },
};
</script>

<style>
</style>